// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xOy-s","name":"Header_name__1tL0O","birthday":"Header_birthday__lmk_5","skeleton":"Header_skeleton__2iZPx"};